const JSON_INDENT = 2;

/**
 * Pretty print a JSON string. Falls back to the raw value when it is not valid JSON.
 * @param {string | null | undefined} value - Raw JSON string from the API
 * @returns {{ formatted: string, isValid: boolean }}
 */
export const formatJsonCode = (value) => {
  if (!value) return { formatted: '', isValid: false };

  try {
    return { formatted: JSON.stringify(JSON.parse(value), null, JSON_INDENT), isValid: true };
  } catch {
    return { formatted: value, isValid: false };
  }
};

/**
 * Build the file name used to download a JSON code item
 * @param {string | null | undefined} id - Dashboard item id
 * @returns {string}
 */
export const buildJsonDownloadFileName = (id) => `${id || 'code'}.json`;
